/**
 * Keeps app-rendered navigation links on the shopper's current language.
 *
 * The Globo Mega Menu builds the nav client-side from links stored in the app.
 * Entries picked with the resource picker come back already localised
 * (/zh/products/...), but entries typed as full URLs are emitted verbatim, so
 * clicking one drops the shopper back to the default language. The app's image
 * blocks only accept a plain URL, so several of those cannot be fixed in the
 * app admin at all.
 *
 * This rewrites *only* same-origin menu links that are missing the locale
 * prefix. It is a targeted patch over bad data in a third-party app, not a
 * general link rewriter: it never runs on the default language, never touches
 * links outside the menu, and never touches other hosts.
 *
 * The real fix for the text links is to re-pick them in the Globo admin.
 */
(function () {
  var root = document.documentElement.getAttribute('data-locale-root');

  // Default language needs no prefix — nothing to do.
  if (!root || root === '/') return;

  var prefix = root.replace(/\/+$/, '');
  if (!prefix) return;

  var MENU_LINKS = '.gm-menu a[href], a.gm-target[href]';

  /** Paths that must never be prefixed. */
  function isExempt(pathname) {
    return (
      pathname.indexOf('/cdn/') === 0 ||
      pathname.indexOf('/admin') === 0 ||
      pathname.indexOf('/apps/') === 0 ||
      pathname.indexOf('/.well-known/') === 0
    );
  }

  function hasPrefix(pathname) {
    return pathname === prefix || pathname.indexOf(prefix + '/') === 0;
  }

  function localize(link) {
    var href = link.getAttribute('href');
    if (!href) return;

    // Skip anchors, mailto:, tel:, javascript: and protocol-relative externals.
    if (href.charAt(0) === '#') return;
    if (/^[a-z][a-z0-9+.-]*:/i.test(href) && !/^https?:/i.test(href)) return;

    var url;
    try {
      url = new URL(href, window.location.origin);
    } catch (e) {
      return;
    }

    if (url.host !== window.location.host) return;
    if (isExempt(url.pathname) || hasPrefix(url.pathname)) return;

    link.setAttribute('href', prefix + url.pathname + url.search + url.hash);
  }

  function run() {
    var links = document.querySelectorAll(MENU_LINKS);
    for (var i = 0; i < links.length; i++) localize(links[i]);
  }

  run();

  // The menu is injected after load, and re-rendered on breakpoint changes,
  // so watch for it rather than relying on a single pass.
  if (window.MutationObserver) {
    var scheduled = false;
    var observer = new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(function () {
        scheduled = false;
        run();
      });
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
